import types from './action-types';

const moduleName = 'gis-map';
const service = abp.services.api.gisMapDataService;

const buildReadonlyGisUrl = (projectId, loadLinkedProjects) => {
    const query = $.param({
        projectId,
        loadLinkedProjects
    });

    return `/api/publicApi/GetReadonlyGisData?${query}`;
};

const getReadonlyGisData = (projectId, loadLinkedProjects) => {
    return $.ajax({
        url: buildReadonlyGisUrl(projectId, loadLinkedProjects),
        type: 'GET',
        dataType: 'json',
        cache: false
    });
};

export const filterData = (visible, projectId, axisId, chapterId, profileId) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.FILTER_CHANGED,
            data: { visible, projectId, axisId, chapterId, profileId }
        });
    }
};

export const filterAuxDrawings = (visible, projectId, drawingId) => {
  return (dispatch, getState) => {
      dispatch({
          type: types.AUXDRAWINGS_CHANGED,
          data: { visible, projectId, drawingId }
      });
  }
};

export const filterDataByDates = (dateFrom, dateTo) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.DATE_FILTER_CHANGED,
            data: { dateFrom, dateTo }
        });
    }
};

export const displayModeChanged = (selectedDisplayMode) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.DISPLAY_MODE_CHANGED,
            data: { selectedDisplayMode }
        });
    }
};

export const toggleFilter = (visible) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.TOGGLE_FILTER,
            data: { visible }
        });
    }
};

export const zoomChanged = (zoom) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ZOOM_CHANGED,
            data: { zoom }
        });
    }
};

export const loadData = (projectId, useReadonlyGisDataProvider) => {
    return (dispatch) => {
        loadDataInternal(projectId, useReadonlyGisDataProvider, dispatch);
    }
};

export const loadLinkedData = (projectId, useReadonlyGisDataProvider) => {
    return (dispatch) => {
        loadLinkedDataInternal(projectId, useReadonlyGisDataProvider, dispatch);
    }
}

const loadDataInternal = (projectId, useReadonlyGisDataProvider, dispatch) => {
    dispatch({ type: types.LOADING, projectId });
    const request = useReadonlyGisDataProvider
        ? getReadonlyGisData(projectId, false)
        : service.getData(projectId);

    request
        .done(result => {
            if (result == null) {
                service.restartCache();
                window.location.reload();
            }
            dispatch({
                type: types.DATA_LOADED,
                data: result
            });
        });
};

const loadLinkedDataInternal = (projectId, useReadonlyGisDataProvider, dispatch) => {
    const request = useReadonlyGisDataProvider
        ? getReadonlyGisData(projectId, true)
        : service.getLinkedData(projectId);

    request
        .done(result => {
            dispatch({
                type: types.LINKEDDATA_LOADED,
                data: result
            });
        })
}



// WEBPACK FOOTER //
// ./App/components/modules/gis-map/actions.js